import { Card, Text, Link, Page } from "@shopify/polaris";

const Support = () => {
  return (
    <Page narrowWidth title='Support'>
      <Card>
        <Text as='p'>
          Need help? We're here for you! If you have any questions or issues,
          feel free to reach out to us via email. Contact us at{" "}
          <Link url='mailto:support@book-ease.com'>
            support@book-ease.com
          </Link>
        </Text>
      </Card>
    </Page>
  );
};

export default Support;
